import type { Filters } from '@ipfabric/utils';
import type { FC } from 'react';

import { Link } from '@ipfabric/ui-components/Link/Link';
import { prop } from '@ipfabric/utils/fp/prop';
import type { DeviceViewEntityId } from 'components/DeviceView/deviceViewTypes';
import { useDeviceViewContextSelectors } from 'components/DeviceView/model/DeviceViewModel';
import { showTable } from 'components/DeviceView/model/commands/showTable';

export type CloudResourceKind = 'route' | 'routeTable';

interface Props {
  deviceViewEntityId: DeviceViewEntityId;
  kind: CloudResourceKind;
  /** Id of the resource; also the link label. */
  id: string;
  /** Route only: the table it belongs to, to pin the row. */
  routeTableId?: string;
}

const webEndpointByKind: { [Kind in CloudResourceKind]: string } = {
  route: '/technology/cloud/route-tables/routes',
  routeTable: '/technology/cloud/route-tables/inventory',
};

const getFilter = (props: Props): Filters => {
  if (props.kind === 'routeTable') {
    return { routeTableId: ['eq', props.id] };
  }
  return props.routeTableId === undefined
    ? { destination: ['eq', props.id] }
    : {
        and: [
          { routeTableId: ['eq', props.routeTableId] },
          { destination: ['eq', props.id] },
        ],
      };
};

/**
 * A cloud id in a decision row, opening the table that lists it as a tab of the
 * construct — the way the on-prem table opens `vRoute` / `vArp`.
 */
export const CloudResourceLink: FC<Props> = (props) => {
  const ctxProps = useDeviceViewContextSelectors({
    dispatch: prop('dispatch'),
  });
  return (
    <Link
      onClick={() => {
        ctxProps.dispatch(showTable, {
          deviceViewEntityId: props.deviceViewEntityId,
          filter: getFilter(props),
          webEndpoint: webEndpointByKind[props.kind],
        });
      }}
      renderAs='button'
    >
      {props.id}
    </Link>
  );
};
